<template>
  <div>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete product/service</p>
          <button class="delete" aria-label="close" @click="closeModal"></button>
        </header>
        <section class="modal-card-body">
          Are you sure do you to delete record?
          <strong>{{ productOrServiceState.name }}</strong
          >
          <br />
          <br />
          <p>
            <strong>Note: </strong>
            <i
              >Deleting this won't permanently delete the product/service name associated
              with the created P.O.</i
            >
          </p>
          <br />
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button :class="dangerButton" @click="deleteProductOrService">
            Okay
          </button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  data() {
    return {
      dangerButton: appButton.isLoadingDanger(false),
    };
  },
  computed: {
    ...mapState("productorservice", {
      showDeleteModal: (state) => state.showDeleteModal,
      productOrServiceState: (state) => state.productOrServiceState,
    }),
  },
  methods: {
    ...mapActions("productorservice", ["openDeleteModal", "getPaginatedData"]),
    deleteProductOrService() {
      this.dangerButton = appButton.isLoadingDanger(true);
      axios
        .delete(
          `api/productsorservices/${this.productOrServiceState.productOrServiceId}`
        )
        .then((response) => {
          appToast.success(response.data);
          this.default();
        })
        .catch((error) => {
          console.log(error);
          appToast.danger(error.response.data);
        })
        .then(() => {
          this.dangerButton = appButton.isLoadingDanger(false);
        });
    },
    closeModal() {
      this.default();
    },
    default() {
      this.openDeleteModal({
        showDeleteModal: false,
      });
      this.getPaginatedData({
        page: 1,
        pageSize: 10,
        query: "",
      });
    },
  },
};
</script>
